import { Helmet } from "react-helmet-async";

interface JsonLdProps {
  schema: Record<string, any> | Record<string, any>[];
}

export function JsonLd({ schema }: JsonLdProps) {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema).replace(/</g, "\\u003c")}
      </script>
    </Helmet>
  );
}
